import { defineStore } from 'pinia'

export const useChecklistStore = defineStore('checklist', () => {
  const count = ref(0)
  const isLoading = ref(false)

  const setCount = (newCount: number) => {
    count.value = newCount
  }

  const setLoading = (loading: boolean) => {
    isLoading.value = loading
  }

  const incrementCount = () => {
    count.value++
  }

  const decrementCount = () => {
    if (count.value > 0) {
      count.value--
    }
  }

  const resetCount = () => {
    count.value = 0
  }

  return {
    count,
    isLoading,
    setCount,
    setLoading,
    incrementCount,
    decrementCount,
    resetCount
  }
})
